import { render, staticRenderFns } from "./PreviewWalletWithhold.vue?vue&type=template&id=6e40ca55&scoped=true"
import script from "./PreviewWalletWithhold.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewWalletWithhold.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PreviewWalletWithhold.vue?vue&type=style&index=0&id=6e40ca55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40ca55",
  null
  
)

export default component.exports